export enum SettingsPath {
  activeTab = "activeTab"
}

export interface PathParams {
  [SettingsPath.activeTab]: string;
}
